module.exports = __webpack_public_path__ + "img/2.ba150ad4.jpg";